export default __webpack_public_path__ + "static/media/in-bond-light.776e19a3.svg";